var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateAds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.083 4.83203C14.083 2.6229 15.8739 0.832031 18.083 0.832031H28.4163C30.6255 0.832031 32.4163 2.62289 32.4163 4.83203V15.1654C32.4163 17.3745 30.6255 19.1654 28.4163 19.1654H26.583V16.6654C26.583 16.2051 26.2099 15.832 25.7497 15.832C25.2894 15.832 24.9163 16.2051 24.9163 16.6654V19.1654H21.583V16.6654C21.583 16.2051 21.2099 15.832 20.7497 15.832C20.2894 15.832 19.9163 16.2051 19.9163 16.6654V19.1654H18.083C15.8739 19.1654 14.083 17.3745 14.083 15.1654V4.83203ZM17.833 7.4987C17.833 7.03846 18.2061 6.66537 18.6663 6.66537H27.833C28.2932 6.66537 28.6663 7.03846 28.6663 7.4987C28.6663 7.95894 28.2932 8.33203 27.833 8.33203H18.6663C18.2061 8.33203 17.833 7.95894 17.833 7.4987ZM18.6663 10.832C18.2061 10.832 17.833 11.2051 17.833 11.6654C17.833 12.1256 18.2061 12.4987 18.6663 12.4987H27.833C28.2932 12.4987 28.6663 12.1256 28.6663 11.6654C28.6663 11.2051 28.2932 10.832 27.833 10.832H18.6663Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 6,
    width: 2,
    height: 8,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 11,
    width: 2,
    height: 8,
    rx: 1,
    transform: "rotate(-90 2.25 11)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAds);
export default __webpack_public_path__ + "static/media/create_ads.8232526056588fa528f1c3a39bd6a742.svg";
export { ForwardRef as ReactComponent };